import React from 'react';
import { CtaButton } from './CtaButton';
import { price } from '../data/landing';
export function Pricing() {
  return <section id="comprar" className="w-full scroll-mt-20 bg-clay text-cream" aria-labelledby="precio-titulo" data-id="element-83" data-mp="2aqj5biozh6j5">
      <div className="mx-auto max-w-content px-6 py-16 text-center md:py-24" data-id="element-84" data-mp="2oktl3aj05qd2">
        <h2 id="precio-titulo" className="font-display text-3xl font-semibold sm:text-4xl" data-id="element-85" data-mp="2jk5wswm5rnmj">
          Precio de lanzamiento
        </h2>
        <p className="mx-auto mt-4 max-w-xl font-sans text-lg text-cream/85" data-id="element-86" data-mp="1rt87m2j02l5t">
          Queremos que profesionalices tu pasión ahora mismo.
        </p>

        <div className="mt-10" data-id="element-87" data-mp="25q4w3xbnbqjj">
          <p className="font-sans text-sm uppercase tracking-[0.2em] text-cream/70" data-id="element-88" data-mp="20sli8yiv1fs4">
            Inversión única hoy
          </p>
          <p className="mt-2 font-display text-6xl font-semibold leading-none tracking-tight sm:text-7xl lg:text-8xl" data-id="element-89" data-mp="3h639gdduwyqk">
            {price.today}
          </p>
          <p className="mt-3 font-sans text-base text-cream/80" data-id="element-90" data-mp="3vzp5xj5hic9j">
            {price.currency} · pago único ·{' '}
            <span className="line-through" data-id="element-91" data-mp="4smcel26btw5">{price.total}</span>
          </p>
        </div>

        <p className="mx-auto mt-8 max-w-md font-sans text-base leading-relaxed text-cream/85" data-id="element-92" data-mp="9siak3o6wr3s">
          Menos de lo que cobrás por una sola sesión. Se paga solo con el primer
          paciente nuevo que reagende.
        </p>

        <div className="mt-10 flex justify-center" data-id="element-93" data-mp="3da0ieb3ypy47">
          <CtaButton tone="cream" data-id="element-94" data-mp="3i81xkky9pdae" />
        </div>
      </div>
    </section>;
}